module.exports = __webpack_public_path__ + "img/stock3.288b4364.png";